import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useGetDriverReportAndConflictDetails = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [driverReportAndConflictDetailsData, setDriverReportAndConflictDetailsData] = useState<any>(null);

    const onGetDriverReportAndConflictDetailsError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while accepting kyc.',
        );
        setShowSuccessModal(true);
        setDriverReportAndConflictDetailsData({ data: "data" });
    };

    const onGetDriverReportAndConflictDetailsSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        if (data) {
            setShowSuccessModal(true);
        } else {
            setDriverReportAndConflictDetailsData(data);
        }
    };

    const getDriverReportAndConflictDetails = async (data: any) => {
        const url: HttpConfig = {
            url: 'warehouse-service/ba/v1/aisle?page=0&size=1000',
            method: 'post',
            data: data
        };

        await request(url, onGetDriverReportAndConflictDetailsSuccess, setLoading, onGetDriverReportAndConflictDetailsError);
    };

    return { getDriverReportAndConflictDetails, loading, showSuccessModal, setShowSuccessModal, driverReportAndConflictDetailsData, setDriverReportAndConflictDetailsData };
};

export default useGetDriverReportAndConflictDetails;
